var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2121:10850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1221 12.5356C10.8435 12.2568 10.5127 12.0357 10.1486 11.8848C9.78448 11.7339 9.39421 11.6562 9.00009 11.6562C8.60596 11.6562 8.21569 11.7339 7.85159 11.8848C7.48749 12.0357 7.15669 12.2568 6.87809 12.5356L0.0380859 19.3756C0.130547 20.6297 0.692994 21.8027 1.61296 22.66C2.53292 23.5173 3.7426 23.9957 5.00009 23.9996H19.0001C19.9798 23.9994 20.9376 23.7096 21.7531 23.1666L11.1221 12.5356Z",
    fill: "#FFD8AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8C19.1046 8 20 7.10457 20 6C20 4.89543 19.1046 4 18 4C16.8954 4 16 4.89543 16 6C16 7.10457 16.8954 8 18 8Z",
    fill: "#FFD8AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C3.67441 0.00158786 2.40356 0.528882 1.46622 1.46622C0.528882 2.40356 0.00158786 3.67441 0 5L0 16.586L5.464 11.122C5.92831 10.6576 6.47956 10.2892 7.08628 10.0378C7.69299 9.78644 8.34328 9.65707 9 9.65707C9.65672 9.65707 10.307 9.78644 10.9137 10.0378C11.5204 10.2892 12.0717 10.6576 12.536 11.122L23.167 21.753C23.71 20.9375 23.9998 19.9797 24 19V5C23.9984 3.67441 23.4711 2.40356 22.5338 1.46622C21.5964 0.528882 20.3256 0.00158786 19 0V0ZM18 10C17.2089 10 16.4355 9.7654 15.7777 9.32588C15.1199 8.88635 14.6072 8.26164 14.3045 7.53073C14.0017 6.79983 13.9225 5.99556 14.0769 5.21964C14.2312 4.44371 14.6122 3.73098 15.1716 3.17157C15.731 2.61216 16.4437 2.2312 17.2196 2.07686C17.9956 1.92252 18.7998 2.00173 19.5307 2.30448C20.2616 2.60723 20.8864 3.11992 21.3259 3.77772C21.7654 4.43552 22 5.20887 22 6C22 7.06087 21.5786 8.07828 20.8284 8.82843C20.0783 9.57857 19.0609 10 18 10Z",
    fill: "#FFD8AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121:10850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.4dceebb1fb613fc30f65ee465f91a532.svg";
export { ForwardRef as ReactComponent };